import { usePermission } from "@ctsu/loader";

// Help topic permissions used by HelpContainer contextPermissions
export const useHelpContextPermissions = () => {
  const canViewSetupHelpBrowser = usePermission("protocol.setup.help-browser");
  const canViewOpenRaveView = usePermission(
    "protocol.setup.help-openrave-view"
  );
  const canViewOpenRaveEdit = usePermission(
    "protocol.setup.help-openrave-edit"
  );
  const canViewOpenRaveSignoffs = usePermission(
    "protocol.setup.help-openrave-signoffs"
  );
  const canViewOpenRaveSignoffsEdit = usePermission(
    "protocol.setup.help-openrave-signoffs-edit"
  );
  const canViewRegulatoryView = usePermission(
    "protocol.setup.help-regulatory-view"
  );
  const canViewRegulatoryEdit = usePermission(
    "protocol.setup.help-regulatory-edit"
  );
  const canViewRegulatorySignoffs = usePermission(
    "protocol.setup.help-regulatory-signoffs"
  );
  const canViewRegulatorySignoffsEdit = usePermission(
    "protocol.setup.help-regulatory-signoffs-edit"
  );


  return [
    {
      ckey: "HELP-PROTOCOL-SETUP-HELP-BROWSER",
      canView: canViewSetupHelpBrowser
    },
    {
      ckey: "HELP-PROTOCOL-SETUP-OPENRAVE-VIEW",
      canView: canViewOpenRaveView
    },
    {
      ckey: "HELP-PROTOCOL-SETUP-OPENRAVE-EDIT",
      canView: canViewOpenRaveEdit
    },
    {
      ckey: "HELP-PROTOCOL-SETUP-OPENRAVE-SIGNOFF",
      canView: canViewOpenRaveSignoffs
    },
    {
      ckey: "HELP-PROTOCOL-SETUP-SIGNOFF-EDIT",
      canView: canViewOpenRaveSignoffsEdit
    },
    {
      ckey: "HELP-PROTOCOL-SETUP-REGULATORY",
      canView: canViewRegulatoryView
    },
    {
      ckey: "HELP-PROTOCOL-REGULATORY-EDIT",
      canView: canViewRegulatoryEdit
    },
    {
      ckey: "HELP-PROTOCOL-REGULATORY-REQUEST",
      canView: canViewRegulatorySignoffs
    },
    {
      ckey: "HELP-PROTOCOL-REG-SIGNOFF-EDIT",
      canView: canViewRegulatorySignoffsEdit
    }
  ];
};
